import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import Toolbar from "@mui/material/Toolbar";
import { Link, useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";
import moment from "moment";
import { TextField, Autocomplete, Table, Grid, Modal, useMediaQuery } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Box from "@mui/material/Box";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import { showComponent } from "../../helper/helpers";
import "../../helper/helper.css";
import { userStatusOption, userTypes } from "../../../constants/masterUserConstants";
import { usersListGuide } from "./guide";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";
import ErrorModal from "../../../utils/components/errorModal";
import ListWrap from "../../commonComponent/listWrap";
import ExcelDownload from "../../../utils/components/excelDownload";
import { paginationrowsPerPageOptions } from "../../../constants/commonConst";

// datatablse packages
var $ = require("jquery");
$.DataTable = require("datatables.net");

const notNeededColumn = ["id"];

const columns = [
  { id: "id", label: "Sr. No.", minWidth: 20 },
  { id: "userName", label: "User Name", minWidth: 40 },
  // { id: "password", label: "Password", minWidth: 40 },
  { id: "type", label: "Type", minWidth: 40 },
  { id: "branches", label: "Branches", minWidth: 40 },
  { id: "companyName", label: "Company Name", minWidth: 40 },
  { id: "userStatus", label: "Status", minWidth: 60 },
];

function createData(id, userName, password, type, branches,companyName, userStatus) {
  return {
    id,
    userName,
    password,
    type: userTypes.filter((e) => e.id == type)?.[0]?.label,
    branches,
    companyName,
    userStatus,
  };
}

export default function UserList(props) {
  const usersListGuides = usersListGuide();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const urlPath = useLocation();
  const [page, setPage] = React.useState(sessionStorage.getItem("ListPageCount") || 0);
  const [rowsPerPage, setRowsPerPage] = React.useState(sessionStorage.getItem("ListRowsPerPage") || 30);
  const [quotationList, setQuotationList] = React.useState([]);
  const [userData, setUserData] = React.useState([]);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "User Name");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const [totalRows, setTotalRows] = React.useState(0);
  const _clientId = localStorage.getItem("clientId");
  const userType = localStorage.getItem("type");
  const branch = localStorage.getItem("branch");  
  const [searched, setSearched] = React.useState(false);
  const [editAccess, setEditAccess] = React.useState(localStorage.getItem("editAccess")?.split(",").map(Number));
  const [excelData, setExcelData] = React.useState([]); 

  const [title, setTitle] = useState("");
  const [errormodalIsOpen, setErrorModalIsOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [filterModalOpen, setFilterModalOpen] = React.useState(false);

  const handleFilterOpen = () => setFilterModalOpen(true);
  const handleFilterClose = () => setFilterModalOpen(false);

  const openErrorModal = (errorMessage,stackTrace,fileName) => {
    setErrorMessage({ errorMessage, stackTrace, fileName });
    setErrorModalIsOpen(true);
  };
  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    sessionStorage.setItem("ListRowsPerPage", event.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const submitSiteDelete = (id) => {
    props.setLoader(true);
    let url = BASE_URL;
    axiosWithToken
      .delete(url + `users/${id}`)
      .then((res) => {
        toast("User is deleted!");
        props.setLoader(false);
        setTimeout(refresh, 500);
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(<h6 onClick={() => openErrorModal(err.message, "submitSiteDelete" ,"User List")}><u>Error: {err.message}</u></h6>);
        }
        // props.setLoader(false);
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };
  const storedSearchBy = sessionStorage.getItem("searched");
  const getQuery = (count = false, removePagination = false) => {
    let whereConditions = "";
    let pagination = "";

    if (searchBy !== "" && searchKey !== "") {
      let colName = {
        "User Name": "users.userName",
        "Company Name": "users.companyName",
        Branch: "branch.branchName",
      }[searchBy];

      //  Special handling for Status
      if (searchBy === "Status") {
        const statusObj = userStatusOption.find((opt) => opt.label.toLowerCase() === searchKey.toLowerCase());
        if (statusObj) {
          whereConditions = `users.userStatus = ${statusObj.id}`;
        } else {
          whereConditions = `1 = 0`; // no result if invalid status typed
        }
      } else if (colName) {
        whereConditions = `LOWER(${colName}) LIKE LOWER('%${searchKey}%')`;
      }
    }

    if (to != null && from != null) {
      if (whereConditions !== "") {
        whereConditions += " and ";
      }

      whereConditions += `(date between ${moment(from).format(
        "YYYY-MM-DD"
      )} and ${moment(to).format("YYYY-MM-DD")})`;
    }

    whereConditions +=
      (userType == 4 || userType == 5) && branch && branch.length
        ? (whereConditions ? " and " : "") + ` branch in (${branch})`
        : "";
    if (!removePagination && rowsPerPage != -1) {
      pagination = ` LIMIT ${rowsPerPage} OFFSET ${
        Number(page) * rowsPerPage
      } `;
    }

    // let baseQuery = `SELECT id, userName, password, type, branch FROM users WHERE status = 1`;

    let baseQuery = `SELECT users.id, users.userName,users.companyName, users.password, users.type, users.branch, users.userStatus, branch.branchName FROM users LEFT JOIN  branch ON users.branch = branch.id WHERE users.status = 1`;

    if (whereConditions !== "") {
      baseQuery += ` AND ${whereConditions}`;
    }

    let data = {
      query: `${baseQuery} ORDER BY id DESC ${pagination}`,
    };

    if (count) {
      data.query = `SELECT COUNT(users.id) AS no_of_rows FROM users LEFT JOIN  branch ON users.branch = branch.id WHERE users.status = 1 ${whereConditions !== ""  ? ` AND ${whereConditions}` :""}`;
    }

    return data;
  };

  function getClientList() {
    let data = getQuery();
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        axiosWithToken.get(BASE_URL + "branch?_where=status=1").then((res2) => {
          let tmp = {};
          res2.data.map((b) => (tmp[b.id] = b));
          let users = res.data;
          var rowData = [];
          for (let i = 0; i < users.length; i++) {
            rowData.push(
              createData(
                users[i].id,
                users[i].userName,
                Array.from({ length: users[i].password.length }, (_, index) => (
                  <FiberManualRecordIcon key={index} sx={{fontSize:"0.4rem"}} />
                )),
                // users[i].password,
                users[i].type,
                (users[i].branch?.split(",") || [])
                  ?.map((e) => tmp[e]?.branchName)
                  ?.join(","),
                  users[i].companyName,
                userStatusOption.find((opt)=>opt.id == users[i].userStatus)?.label || "",
              )
            );
          }
          setUserData(rowData);
        });
      })
      .catch((err) => {
        console.log("clients data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(<h6 onClick={() => openErrorModal(err.message, "getClientList" ,"User List")}><u>Error: {err.message}</u></h6>);
        }
      });
  }

  // api calls
  function getTotalRows() {
    let data = getQuery(true);
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.log("clients data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(<h6 onClick={() => openErrorModal(err.message, "getTotalRows" ,"User List")}><u>Error: {err.message}</u></h6>);
        }
      });
  }

  function fetchAllDataForExcel() {
  const data = getQuery(false, true);
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        axiosWithToken
          .get(BASE_URL + "branch?_where=status=1")
          .then((res2) => {
            let branchMap = {};
            res2.data.forEach((b) => branchMap[b.id] = b);
            const processed = res.data.map((item) => {
              return {
                id: item.id || "",
                userName: item.userName || "",
                password: "*****",
                type: userTypes.find((t) => t.id == item.type)?.label || "",
                branch: (item.branch?.split(",") || [])
                  ?.map((e) => branchMap[e]?.branchName)
                  ?.join(", ") || "",
                companyName: item.companyName || "",
                status: userStatusOption.find((opt) => opt.id == item.userStatus)?.label || "",
              };
            });
            setExcelData(processed);
          });
      })
      .catch((err) => {
        console.log("Failed to fetch data for Excel export", err);
      });
  }

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  useEffect(() => {
    if(storedSearchBy){
      setSearched(true);
    }
  }, [storedSearchBy]);

  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setPage(0);
    setSearched(true);
    getClientList();
    getTotalRows();
    fetchAllDataForExcel();
  };
  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched", searched);
    sessionStorage.removeItem("currentPath");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    setPage(0);
    setSearchBy("User Name");
    setSearchKey("");
    setSearched(false); 
  };
  
  useEffect(() => {
      getClientList();
      getTotalRows();
  }, [rowsPerPage, page]);

  useEffect(() => {
    if(searched==false){
      getClientList();
      getTotalRows();
      fetchAllDataForExcel();
    }
    if (searched) {
      setPage(sessionStorage.getItem("ListPageCount") || 0);
    }
  }, [searched]);

  const filterSection = () => (
    <Grid
      container
      spacing={2}
      alignItems="center"
      style={{ padding: "5px 0px" }}
    >
      <Grid item xs={6} sm={6} md={2} lg={2}>
      <Autocomplete
          sx={{
            m: 0,
            width: "100%",
          }}
          size="small"
          className="Listinputcss"
          id="users_list_searchby"
          value={searchBy}
          options={[
            { key: "username", label: "User Name" },
            { key: "companyName", label: "Company Name" },
            { key: "branch", label: "Branch" },
            { key: "userStatus", label: "Status" },
          ]}
          renderInput={(params) => <TextField {...params} label="Search By" />}
          onInputChange={(event, newInputValue) => {
            setSearchBy(newInputValue);
            setSearched(false);
          }}
        />
      </Grid>
      <Grid item xs={6} sm={6} md={2} lg={2}>
      <TextField
      style={{ width: "100%" }}
          id="users_list_searchbytext"
          label={"enter " + searchBy}
          inputProps={{
            autoComplete: 'off',
          }}
          className="Listinputcss"
          size="small"
          variant="outlined"
          value={searchKey}
          onChange={(e) => {
            setSearchKey(e.target.value)
            setSearched(false);
          }}
        />
      </Grid>
      <Grid item xs={6} sm={6} md={1} lg={1} textAlign={"left"}>
      <Button
          id="users_list_searchbtn"
          variant="contained"
          size="small"
          color={searched ? "error" : "primary"}
          onClick={() => {
            searched ? clearSearch() : search();
          }}
        >
          {searched ? <RestartAltIcon /> : <SearchIcon />}
        </Button>
      </Grid>
      {!isMobile && (editAccess?.includes(4) || editAccess?.includes(0)) && (
        <Grid item xs={6} sm={6} md={2} lg={1.5} textAlign={"left"}>
          <ExcelDownload
            finalData={excelData}
            notNeededColumn={notNeededColumn}
          />
        </Grid>
      )}
    </Grid>
  );

  const filterModal = () => {
    return (
      <Modal open={filterModalOpen} size="md">
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "calc(100% - 30%)",
            backgroundColor: "white",
            // border: "2px solid #000",
            boxShadow: 24,
            padding: "10px",
          }}
        >
          <Button
            variant="contained"
            size="small"
            color="error"
            style={{ float: "right" }}
            onClick={handleFilterClose}
          >
            X
          </Button>
          {filterSection()}
        </Box>
      </Modal>
    );
  };

  return (
    <ListWrap>
      {filterModal()}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Toolbar style={{ padding: "0px" }}>
          {showComponent("add") && (
            <Button
              id="users_list_createbtn"
              variant="contained"
              size="small"
              component={Link}
              to="/master/users/addUser"
              onClick={() => {
                setTitle("Master/ add new user");
              }}
            >
              <b>create user</b>
            </Button>
          )}
        </Toolbar>
        <Box sx={{ display: "flex", gap: "0rem" }}>
              <Button
                style={{ display: isMobile ? "block" : "none" }}
                onClick={handleFilterOpen}
              >
                <FilterAltIcon />
              </Button>
        <Tooltip title="User Guide" placement="top-start">
          <Button
            onClick={() => {
              usersListGuides.drive();
            }}
          >
            <HelpIcon />
          </Button>
        </Tooltip>
        </Box>
      </div>
      {!isMobile && filterSection()}
     
      <Box sx={{ width: "100%", overflow: "hidden", display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
        <TableContainer sx={{ flex: 1, overflow: 'auto' }}>
          <Table
            stickyHeader
            aria-label="sticky table"
            size="small"
            id="datatable-keytable"
            width="100%"
            sx={{ borderCollapse: "collapse" }}
          >
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  <b>{column.label}</b>
                </TableCell>
              ))}
              <TableCell>
                <b>Actions</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userData?.length > 0 ? (
              userData.map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    {columns.map((column) => {
                      let value = row[column.id];
                      if (column.id == "id") {
                        value = page * rowsPerPage + (index + 1);
                      }
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                    <TableCell>
                      <ButtonGroup
                        size="small"
                        aria-label="small button group"
                        className="action-container"
                      >
                        {showComponent("show") && (
                          <Tooltip title="Edit User" placement="top-start">
                            <Button
                              id="users_list_edit"
                              component={Link}
                              to={`/master/users/editUser/${row.id}`}
                            >
                              <PreviewIcon />
                            </Button>
                          </Tooltip>
                        )}
                        {showComponent("delete") && (
                          <Tooltip title="Delete User" placement="top-start">
                            <Button
                              id="users_list_delete"
                              disabled={!(editAccess?.includes(2) || editAccess?.includes(0))}
                              onClick={(e) => {
                                if (
                                  window.confirm("Really want to delete User?")
                                ) {
                                  submitSiteDelete(row.id);
                                }
                              }}
                            >
                              <DeleteIcon style={{ color:!(editAccess?.includes(2) || editAccess?.includes(0)) ? 'lightgray' : '#dc3545' }}/>
                            </Button>
                          </Tooltip>
                        )}
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                 <h6><b>Data Not Found</b></h6>
                </TableCell>
              </TableRow>
            )} 
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={paginationrowsPerPageOptions}
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          component="div"
          colSpan={3}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          ActionsComponent={TablePaginationActions}
        />
      </Box>
      <ToastContainer />
      {errormodalIsOpen && <ErrorModal errormodalIsOpen={errormodalIsOpen} closeErrorModal={closeErrorModal} errorMessage={errorMessage} />}
    </ListWrap>
  );
}
